module.exports = __webpack_public_path__ + "img/fi-rr-smartphone.4b33a5e7.svg";